<!-- Der projizierte Inhalt einmal einfangen: zwei unbenannte <ng-content> in verschiedenen Zweigen
     bekommen den Inhalt nicht beide – Angular projiziert ihn in nur einen Slot, im block-Zweig
     blieb der Abschnitt dadurch leer. -->
<ng-template #projected><ng-content></ng-content></ng-template>
<!-- Kopfzeile nach Figma (#2789): Feld-Label · Badge · Spacer · ✓/✗. Steht über dem Feld und ersetzt
     dessen eigenes Label (per CSS ausgeblendet) sowie die ✓/✗ neben dem Feld. -->
<ng-template #headerRow>
  <!-- Label und Badge stehen in einer eigenen, umbrechenden Gruppe: In schmalen Spalten (Tag-Zeile im
       Hybrid-Editor, Regelparameter-Zeile im KI-Editor) bricht erst das Badge, dann das Label um –
       abgeschnitten wird nichts. ✓/✗ bleiben rechts in der ersten Zeile. -->
  <div class="proposal-header flex flex-row items-center gap-2 min-h-[38px] shrink-0">
    <div class="proposal-header-title flex flex-row flex-wrap items-center gap-x-2 gap-y-1 flex-1 min-w-0">
      @if (label) {
        <span class="proposal-header-label text-sm font-medium text-gray-900 min-w-0 break-words">{{ label }}</span>
      }
      <app-proposal-status-badge [status]="status" class="shrink-0"></app-proposal-status-badge>
    </div>
    <app-proposal-actions (acceptClicked)="acceptClicked.emit()"
                          (rejectClicked)="rejectClicked.emit()"
                          [acceptLabel]="acceptLabel"
                          [rejectLabel]="rejectLabel"></app-proposal-actions>
  </div>
</ng-template>
<div class="contents"
     [class.proposal-changed]="!!change && !block"
     [class.proposal-changed-block]="!!change && block"
     [class.proposal-headed]="headed && !!label"
     [class.proposal-removed]="!!change && !block && status === 'removed'">
  @if (block) {
    <ng-container [ngTemplateOutlet]="projected"></ng-container>
    @if (change) {
      <div class="absolute top-2 right-2">
        <app-proposal-actions (acceptClicked)="acceptClicked.emit()"
                              (rejectClicked)="rejectClicked.emit()"></app-proposal-actions>
      </div>
    }
  } @else if (headed) {
    <div [attr.data-proposal-review]="reviewKey ?? null" [class.flex-1]="fill" [class.min-h-0]="fill"
         [ngClass]="rootClass" class="flex flex-col gap-1.5">
      @if (!externalHeader) {
        <ng-container [ngTemplateOutlet]="headerRow"></ng-container>
      }
      @if (textDiff && diffParts.length && showDiffView) {
        <div
          [class.flex-1]="fill"
          [class.min-h-0]="fill"
          [class.overflow-y-auto]="fill"
          class="proposal-diff-view min-w-0 text-sm rounded-lg border border-green-500 p-2.5 whitespace-pre-wrap break-words">
          @for (part of diffParts; track $index) {
            <span [ngClass]="{
              'text-gray-900': part.type === 'equal',
              'text-green-700': part.type === 'added',
              'text-gray-500 line-through': part.type === 'removed'
            }">{{ part.text }}</span>
          }
        </div>
        <button (click)="toggleDiffView()"
                class="self-start flex items-center gap-1 text-sm text-gray-500 hover:text-gray-900"
                type="button">
          <fa-icon [icon]="faPen" class="text-xs"></fa-icon>
          Bearbeiten
        </button>
      } @else {
        <div [class.flex-1]="fill" [class.flex-col]="fill" [class.flex]="fill" [class.min-h-0]="fill" class="min-w-0">
          <ng-container [ngTemplateOutlet]="projected"></ng-container>
        </div>
        @if (textDiff && diffParts.length) {
          <button (click)="toggleDiffView()"
                  class="self-start flex items-center gap-1 text-sm text-gray-500 hover:text-gray-900"
                  type="button">
            Änderungen anzeigen
          </button>
        }
      }
    </div>
  } @else {
    <div [attr.data-proposal-review]="change ? (reviewKey ?? null) : null"
         [class.flex-1]="fill" [class.items-end]="!fill" [class.items-stretch]="fill" [class.min-h-0]="fill"
         [ngClass]="rootClass" class="flex flex-row gap-2">
      <div [class.flex-col]="fill" [class.flex]="fill" class="flex-1 min-w-0">
        <ng-container [ngTemplateOutlet]="projected"></ng-container>
      </div>
      @if (change && actions && !externalHeader) {
        <!-- Die Buttons sind wie bic-input/bic-select 38px hoch und stehen unten bündig mit dem Feld
             (das Label darüber zählt nicht mit). -->
        <app-proposal-actions (acceptClicked)="acceptClicked.emit()"
                              (rejectClicked)="rejectClicked.emit()"
                              [acceptLabel]="acceptLabel"
                              [rejectLabel]="rejectLabel"
                              class="self-end shrink-0"></app-proposal-actions>
      }
    </div>
  }
</div>
